/* src/app/components/forgot-password/forgot.component.scss */
:host {
  display: block;
  min-height: 100vh;
}
.reset-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(
      circle at 8% 8%,
      rgba(37, 59, 128, 0.07),
      transparent 28%),
    radial-gradient(
      circle at 92% 92%,
      rgba(52, 79, 145, 0.06),
      transparent 28%),
    #F4F6FA;
}
.reset-shell {
  width: 100%;
  min-height: 100vh;
  display: grid;
  grid-template-columns: 50% 50%;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.07);
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.1), 0 4px 16px rgba(15, 23, 42, 0.04);
}
.reset-visual {
  position: relative;
  overflow: hidden;
  background: #dfe8fa;
  color: #ffffff;
}
.reset-visual::before {
  content: "";
  position: absolute;
  width: 420px;
  height: 420px;
  top: -180px;
  left: -180px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.07);
}
.reset-visual::after {
  content: "";
  position: absolute;
  width: 360px;
  height: 360px;
  right: -170px;
  bottom: -170px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
}
.visual-content {
  position: relative;
  z-index: 1;
  height: 100%;
  padding: 42px;
  display: flex;
  flex-direction: column;
}
.visual-brand {
  display: flex;
  align-items: center;
}
.visual-brand img {
  width: 225px;
  height: auto;
  max-width: 100%;
  filter: brightness(0) invert(1);
}
.visual-image {
  flex: 1;
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
}
.visual-image img {
  width: 100%;
  max-width: 440px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 20px 30px rgba(0, 0, 0, 0.12));
}
.visual-footer {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-top: 20px;
}
.visual-footer span {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
  color: #253b80;
}
.visual-footer i {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  font-size: 14px;
}
.reset-panel {
  overflow-y: auto;
  background: #ffffff;
}
.reset-content {
  width: min(480px, 100%);
  min-height: 100%;
  margin: 0 auto;
  padding: 60px 54px 38px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.mobile-brand {
  margin-bottom: 32px;
}
.mobile-brand img {
  width: 250px;
  height: auto;
}
.reset-header {
  margin-bottom: 30px;
}
.reset-eyebrow {
  display: inline-flex;
  align-items: center;
  margin-bottom: 10px;
  font-family: "Outfit";
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  color: #253B80;
  letter-spacing: 0.02em;
}
.reset-header h2 {
  margin: 0 0 10px;
  font-family: "Outfit";
  font-size: 30px;
  font-weight: 700;
  line-height: 1.25;
  color: #111827;
}
.reset-header p {
  max-width: 440px;
  margin: 0;
  font-family: "Outfit";
  font-size: 15px;
  line-height: 1.6;
  color: #6B7280;
}
.reset-form {
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.form-field {
  width: 100%;
}
.form-field label {
  display: block;
  margin-bottom: 9px !important;
  font-family: "Outfit";
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  color: #111827;
}
.input-wrapper {
  position: relative;
  width: 100%;
}
.input-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  z-index: 1;
  transform: translateY(-50%);
  font-size: 16px;
  color: #94a3b8;
  pointer-events: none;
  transition: color 0.2s ease;
}
.form-input {
  width: 100%;
  height: 50px;
  padding: 0 15px 0 44px;
  box-sizing: border-box;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  outline: none;
  background: #ffffff;
  color: #111827;
  font-family: "Outfit";
  font-size: 15px;
  line-height: 1.4;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background-color 0.2s ease;
}
.form-input::placeholder {
  color: #9ca3af;
  opacity: 1;
}
.form-input:hover {
  border-color: #aeb8c8;
}
.form-input:focus {
  border-color: #253B80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.1);
}
.input-wrapper:focus-within .input-icon {
  color: #253B80;
}
.reset-button {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 2px;
  border: 0;
  border-radius: 10px;
  background: #253B80;
  color: #ffffff;
  font-family: "Outfit";
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 6px 14px rgba(37, 59, 128, 0.18);
  transition:
    background-color 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease,
    opacity 0.2s ease;
}
.reset-button:hover:not(:disabled) {
  background: #1e316d;
  transform: translateY(-1px);
  box-shadow: 0 9px 20px rgba(37, 59, 128, 0.22);
}
.reset-button:active:not(:disabled) {
  transform: translateY(0);
}
.reset-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}
.reset-button i {
  font-size: 14px;
}
.login-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 2px;
  font-family: "Outfit";
  font-size: 15px;
  line-height: 1.5;
  color: #6B7280;
}
.login-link {
  font-family: "Outfit";
  font-size: 15px;
  font-weight: 600;
  color: #253B80;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;
}
.login-link:hover {
  color: #1e316d;
  text-decoration: underline;
}
.confirmation-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.confirmation-icon {
  width: 64px;
  height: 64px;
  margin-bottom: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #ecfdf3;
  color: #16a34a;
  box-shadow: 0 0 0 8px rgba(22, 163, 74, 0.06);
}
.confirmation-icon i {
  font-size: 27px;
  font-weight: 700;
}
.confirmation-eyebrow {
  margin-bottom: 9px;
  font-family: "Outfit";
  font-size: 13px;
  font-weight: 600;
  color: #16a34a;
}
.confirmation-wrapper h2 {
  margin: 0 0 10px;
  font-family: "Outfit";
  font-size: 30px;
  font-weight: 700;
  line-height: 1.25;
  color: #111827;
}
.confirmation-wrapper > p {
  max-width: 420px;
  margin: 0;
  font-family: "Outfit";
  font-size: 15px;
  line-height: 1.6;
  color: #6B7280;
}
.expiry-info {
  width: 100%;
  margin-top: 24px;
  margin-bottom: 24px;
  padding: 14px 16px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  box-sizing: border-box;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  text-align: left;
  font-family: "Outfit";
  font-size: 13px;
  line-height: 1.5;
  color: #475569;
}
.expiry-info i {
  flex: 0 0 auto;
  margin-top: 2px;
  font-size: 15px;
  color: #253B80;
}
.expiry-info strong {
  font-family: "Outfit";
  font-weight: 600;
  color: #111827;
}
.reset-security {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 28px;
  padding-top: 18px;
  border-top: 1px solid #eef2f7;
  font-family: "Outfit";
  font-size: 13px;
  line-height: 1.4;
  color: #9CA3AF;
}
.reset-security i {
  font-size: 13px;
  color: #64748b;
}
@media (max-width: 1024px) {
  .reset-page {
    padding: 24px;
  }
  .reset-shell {
    grid-template-columns: 40% 60%;
  }
  .visual-content {
    padding: 32px;
  }
  .reset-content {
    padding: 50px 42px 36px;
  }
  .reset-header h2,
  .confirmation-wrapper h2 {
    font-size: 28px;
  }
}
@media (max-width: 800px) {
  .reset-page {
    padding: 20px;
  }
  .reset-shell {
    grid-template-columns: 1fr;
    max-width: 620px;
    min-height: auto;
  }
  .reset-visual {
    display: none;
  }
  .reset-content {
    width: 100%;
    min-height: auto;
    padding: 44px 42px 38px;
  }
  .mobile-brand {
    display: block;
    margin-bottom: 32px;
  }
}
@media (max-width: 600px) {
  .reset-page {
    padding: 0;
    align-items: stretch;
  }
  .reset-shell {
    width: 100%;
    min-height: 100vh;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }
  .reset-content {
    padding: 30px 22px 28px;
  }
  .mobile-brand {
    margin-bottom: 30px;
  }
  .mobile-brand img {
    width: 145px;
  }
  .reset-header {
    margin-bottom: 26px;
  }
  .reset-eyebrow {
    margin-bottom: 8px;
    font-size: 12px;
  }
  .reset-header h2,
  .confirmation-wrapper h2 {
    font-size: 26px;
    line-height: 1.25;
  }
  .reset-header p,
  .confirmation-wrapper > p {
    font-size: 14px;
    line-height: 1.6;
  }
  .form-field label {
    font-size: 14px;
  }
  .form-input {
    height: 50px;
    font-size: 14px;
  }
  .reset-button {
    height: 50px;
    font-size: 14px;
  }
  .login-section {
    font-size: 13px;
  }
  .login-link {
    font-size: 13px;
  }
  .confirmation-icon {
    width: 60px;
    height: 60px;
  }
  .confirmation-icon i {
    font-size: 25px;
  }
  .expiry-info {
    font-size: 13px;
  }
  .reset-security {
    font-size: 12px;
  }
}
@media (max-width: 380px) {
  .reset-content {
    padding: 26px 18px 24px;
  }
  .reset-header h2,
  .confirmation-wrapper h2 {
    font-size: 24px;
  }
  .reset-header p,
  .confirmation-wrapper > p {
    font-size: 13px;
  }
  .form-input,
  .reset-button {
    height: 48px;
  }
}
/*# sourceMappingURL=forgot.component.css.map */
